import { join } from 'light-component';
import { Tooltip } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { Box } from '../../box';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ThumbnailProps } from './types';

export function Thumbnail(props: ThumbnailProps): ReactElement {
  if (props.toolTipContent != null) {
    return (<Tooltip placement='right' title={props.toolTipContent}>
      <Box className={join(styles.control, props.className)}>
        <Icons name={props.icon} className={styles.icon} />
        <Box component='span' className={styles.text}>{props.title}</Box>
      </Box>
    </Tooltip>);
  }
  return (
    <Box className={join(styles.control, props.className)}>
      <Icons name={props.icon} className={styles.icon} />
      <Box component='span' className={styles.text}>{props.title}</Box>
    </Box>
  );
}
